import CustomMetaData, {
  CustomMetaDataProps,
} from 'components/general/customMetaData/CustomMetaData';
import GenericPageLayout, {
  GenericPageLayoutProps,
} from 'components/general/genericPageLayout/GenericPageLayout';
import { useThemeContext } from 'context/ThemeContext';
import { NEXTJS_REVALIDATE_PAGE_IN_SECONDS } from 'pages/index';
import { useEffect } from 'react';
import { parseGenericPage } from 'utils/parsers';

import style from './termsPage.module.scss';

type Props = { generic: GenericPageLayoutProps; text: string; metaData: CustomMetaDataProps };

const Terms = (props: Props) => {
  const { generic, text } = props;

  const { setTheme } = useThemeContext();
  useEffect(() => {
    setTheme('light');
  }, [setTheme]);

  return (
    <GenericPageLayout {...generic} blocks={[]}>
      <CustomMetaData {...props.metaData} />
      <div className={style.text} dangerouslySetInnerHTML={{ __html: text }}></div>
    </GenericPageLayout>
  );
};

export async function getStaticProps(context) {
  const genericProps: GenericPageLayoutProps = await parseGenericPage('/terms-of-use/', context);
  genericProps.blocks = [];

  const props: Props = {
    generic: genericProps,
    text: genericProps.originalResponse.text,
    metaData: {
      titleDefault: genericProps.originalResponse.title,
      title: genericProps.originalResponse.meta_title,
      description: genericProps.originalResponse.meta_description,
      image: genericProps.originalResponse.meta_image,
    },
  };
  // Pass data to the page via props
  return {
    props: props,
    // Next.js will attempt to re-generate the page:
    // - When a request comes in
    // - At most once every 10 seconds
    revalidate: NEXTJS_REVALIDATE_PAGE_IN_SECONDS, // In seconds
  };
}

export default Terms;
